export function filterCompActions(actions, place) {
  const ans = [];
  actions.forEach(action => {
    const iPlace = action.place;
    if (!iPlace) ans.push(action);
    if (Array.isArray(iPlace) && iPlace.includes(place)) ans.push(action);
    if (iPlace === place) ans.push(action);
  });
  return ans;
}
export function getCompActionRenderType(action) {
  if (action.execute || action.icon) return 'action';
  if (action.title === '|' || action.title === '---') return 'separator';
  return 'text';
}
//# sourceMappingURL=compActions.js.map
